var map = {
	"./bongo.jpg": 3662,
	"./chimineas.jpg": 5198,
	"./face_pots.jpg": 5987,
	"./face_shot_glasses.jpg": 5758,
	"./giraffe.jpg": 7681,
	"./llama_ashtray.jpg": 1615,
	"./oil_lamps_lit.jpg": 1475,
	"./pipes.jpg": 4494,
	"./pot_with_plant.jpg": 2443,
	"./seed_pod_lamp.jpg": 9073,
	"./terra_cotta_creatures.jpg": 8482,
	"./vase.jpg": 4770
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6352;